/**
 * API integration: set to false and implement fetch in each suite module
 * (or a shared http client) when connecting a backend.
 */
export const API_USE_MOCK = true;

export const API_BASE_URL =
  typeof process !== "undefined" &&
  process.env &&
  process.env.REACTIFY_API_BASE
    ? process.env.REACTIFY_API_BASE
    : "";
